import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { SqlWeekDay } from '../Enums/SqlWeekDay.enum';
import { TimeTrackingBillingState } from '../Enums/TimeTrackingBillingState.enum';
import { TimeTrackingDeliveryNoteState } from '../Enums/TimeTrackingDeliveryNoteState.enum';

export class TimeTrackingDetails<T extends EMode = EMode.entity> {
  /** Alias: tT_Code */
  id?: number;
  /** Alias: tT_StatusBilling */
  statusBilling?: TimeTrackingBillingState;
  /** Alias: tT_StatusDeliveryNote */
  statusDeliveryNote?: TimeTrackingDeliveryNoteState;
  /** Alias: project_GroupName */
  projectGroupName?: string;
  /** Alias: projectLead_Name */
  projectLeadName?: string;
  /** Alias: project_StatusName */
  projectStatusName?: string;
  /** Alias: parentProject_Name */
  parentProjectName?: string;
  /** Alias: projectStep_Name */
  projectStepName?: string;
  /** Alias: projectStep_TargetHours */
  projectStepTargetHours?: string;
  /** Alias: tT_WeekDay */
  weekDay?: SqlWeekDay;
  /** Alias: tT_Year */
  year?: number;
  /** Alias: tT_Month */
  month?: number;
  /** Alias: tT_Minutes */
  minutes?: number;

  __typename?: string;
}

const fields: FieldDefinitions<TimeTrackingDetails> = {
  id: {
    alias: 'tT_Code',
  },
  statusBilling: {
    alias: 'tT_StatusBilling',
  },
  statusDeliveryNote: {
    alias: 'tT_StatusDeliveryNote',
  },
  projectGroupName: {
    alias: 'project_GroupName',
  },
  projectLeadName: {
    alias: 'projectLead_Name',
  },
  projectStatusName: {
    alias: 'project_StatusName',
  },
  parentProjectName: {
    alias: 'parentProject_Name',
  },
  projectStepName: {
    alias: 'projectStep_Name',
  },
  projectStepTargetHours: {
    alias: 'projectStep_TargetHours',
  },
  weekDay: {
    alias: 'tT_WeekDay',
  },
  year: {
    alias: 'tT_Year',
  },
  month: {
    alias: 'tT_Month',
  },
  minutes: {
    alias: 'tT_Minutes',
  },
  __typename: {
    alias: '__typename',
  },
};

export const timeTrackingDetailsEntityDefinition: EntitiyDefinition<TimeTrackingDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'TimeTrackingDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
